export const mainWebsiteLanguages = [
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
  { label: 'Russian', value: 'ru' },
  { label: 'Italian', value: 'it' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'German', value: 'de' },
  { label: 'Korean', value: 'kr' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Thai', value: 'th' },
  { label: 'Chinese', value: 'zh' },
  { label: 'Polish', value: 'pl' },
  { label: 'Malay', value: 'ms' },
]

export const isChinese = (text: string): boolean => {
  const rgx = /^[\u4e00-\u9fa5]+$/
  return rgx.test(text)
}
